import React from 'react';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
import {
  List,
  ListItem,
  Avatar,
  ListItemText,
  ListItemSecondaryAction,
  Radio,
  Button,
} from '@material-ui/core';
import { useIntl, FormattedMessage } from 'react-intl';
import { Redux, Slices } from 'spwa-ui-library';
import css from './index.module.scss';
import DrawerPwa from '../../components/DrawerPwa';
import DialogBox from '../../components/DialogBox';
import uaeIcon from '../../components/SideMenu/images/uae.png';
import ksaIcon from '../../components/SideMenu/images/ksa.jpg';
const { useDispatch, useSelector } = Redux;
const { selectDesktop } = Slices.appSlice;
// TODO: Do not use a separate container for OTP
// TODO: Find a way to avoid setting proxy in package.json
export let dataList = [
  {
    name_en: 'United Arab Emirates',
    name_ar: 'الإمارات العربية المتحدة',
    code: 'UAE',
    flag: uaeIcon,
    number_code: '(+971)',
  },
  {
    name_en: 'Saudi Arabia',
    code: 'KSA',
    name_ar: 'السعودية',
    flag: ksaIcon,
    number_code: '(+966)',
  },
];
function DrawerCountry({ openDrawerCountry, setCountryDefault }) {
  const isDesktop = useSelector(selectDesktop);
  const intl = useIntl();
  const nameVal = `name_${intl.locale}`;
  const ContentChangeCountry = () => {
    return (
      <>
        <div className={css.countryCheckBox}>
          <h3>
            <FormattedMessage id="changeCountry" defaultMessage="Change Country" />
          </h3>
          <List disablePadding>
            {dataList.map((dataItem, idx) => {
              // if (dataList.country !== dataItem.code) {
              return (
                <ListItem
                  button
                  component="label"
                  htmlFor={idx}
                  ContainerProps={{ className: css.listItem }}
                >
                  <Avatar
                    variant="square"
                    alt={dataItem.name}
                    src={dataItem.flag}
                    className={css.image}
                  />

                  <ListItemText primary={dataItem[nameVal]} className={css.title} />
                  <div className={css.activeBar} />
                  <ListItemSecondaryAction className={css.checkbox}>
                    <Radio checked={true} color="primary" id={idx} edge="end" />
                  </ListItemSecondaryAction>
                </ListItem>
              );
              // } else {
              //   return '';
              // }
            })}
          </List>

          <div className={css.actionContainer}>
            <Button
              variant="contained"
              // disabled={switchCountry === countrySelected}
              color="primary"
              className={css.actionButton}
              onClick={() => {
                setCountryDefault(true);
                openDrawerCountry();
              }}
            >
              <FormattedMessage id="trackorder_done" defaultMessage="Done" />
            </Button>
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      {!isDesktop && (
        <DrawerPwa
          // ModalProps={{
          //   style: {
          //     position: 'absolute',
          //   },
          // }}
          variant="temporary"
          anchor="bottom"
          onClose={openDrawerCountry}
          className={css.nobg}
          open={true}
        >
          <ContentChangeCountry />
        </DrawerPwa>
      )}
      {isDesktop && (
        <DialogBox size="sm" isOpen={true} onClose={openDrawerCountry}>
          <ContentChangeCountry />
        </DialogBox>
      )}
    </>
  );
}

export default DrawerCountry;
